import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';

import Amplify, { Auth } from 'aws-amplify';
// import awsExports from "./aws-exports";
// let x = Amplify.configure(awsExports);
Amplify.configure({
  Auth: {
      // UAT
      identityPoolId: 'eu-west-1:d9ee0bbb-18f2-465f-a8ce-3aa4a23779d3',
      region: 'eu-west-1',
      identityPoolRegion: 'eu-west-1',
      userPoolId: 'eu-west-1_MthjOOfXy',
      userPoolWebClientId: '4oh47hlmskrdf8k4nj2s4996oh',
      mandatorySignIn: false,

      // identityPoolId: 'eu-west-1:d9ee0bbb-18f2-465f-a8ce-3aa4a23779d3',
      // region: 'eu-west-1',
      // identityPoolRegion: 'eu-west-1',
      // userPoolId: 'eu-west-1_MthjOOfXy',
      // userPoolWebClientId: '4oh47hlmskrdf8k4nj2s4996oh',
      // mandatorySignIn: false,

      // OPTIONAL - Configuration for cookie storage
      // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    //   cookieStorage: {
    //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //       domain: '.yourdomain.com',
    //   // OPTIONAL - Cookie path
    //       path: '/',
    //   // OPTIONAL - Cookie expiration in days
    //       expires: 365,
    // //   // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    // //       sameSite: "strict" | "lax",
    //   // OPTIONAL - Cookie secure flag
    //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //       secure: false
    //   },

      // OPTIONAL - customized storage object
    //   storage: MyStorage,

      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      authenticationFlowType: 'CUSTOM_AUTH',

      // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
      clientMetadata: { myCustomKey: 'myCustomValue' },

       // OPTIONAL - Hosted UI configuration
      oauth: {
          domain: 'your_cognito_domain',
          scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: 'http://localhost:3000/',
          redirectSignOut: 'http://localhost:3000/',
          responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
      }
  }
});
const currentConfig = Auth.configure();
console.log(currentConfig)

ReactDOM.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <App />
  </ThemeProvider>,
  document.querySelector('#root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
